export default {
  locations: [],
  location: null,
  costs: [],
  error: false,
  errorMessage: "",
  success: false,
  successMessage: "",
};
